module.exports = __webpack_public_path__ + "img/scene-4.58531cf9.png";